// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthBoxLayout_container__109tf","header":"AuthBoxLayout_header__3ck7D","footer":"AuthBoxLayout_footer__L7XQ-","content":"AuthBoxLayout_content__3VuwY"};